// !!!!!!!! Since these functions has rebuy dependencies please call these functions inside REBUY loaded event callback

async function initIpLookup() {
	try {
		let isInTargetRegion = sessionStorage.getItem("ipGeoLocationData");
		if (isInTargetRegion === null) {
			// const lookUpResp = await fetch("https://us-central1-shopify-web-dev.cloudfunctions.net/ipLookUp");
			const lookUpResp = await Rebuy.getGeolocation();
			sessionStorage.setItem("ipGeoLocationData", JSON.stringify(lookUpResp));
		}
	} catch (error) {
		console.log(error);
	}
}

async function isInTargetRegion(targets = [""]) {
	try {
		if (!targets.length) {
			return false;
		}
		let isInTargetRegion = JSON.parse(sessionStorage.getItem("ipGeoLocationData"));
		if (isInTargetRegion) {
			return targets.some(
				(t) =>
					t.trim().toLowerCase() === isInTargetRegion.city_name.toLowerCase() ||
					t.trim().toLowerCase() === isInTargetRegion.province_name.toLowerCase() ||
					t.trim().toLowerCase() === isInTargetRegion.country_name.toLowerCase()
			);
		} else {
			await initIpLookup();
			let isInTargetRegion = JSON.parse(sessionStorage.getItem("ipGeoLocationData"));
			return targets.some(
				(t) =>
					t.trim().toLowerCase() === isInTargetRegion.city_name.toLowerCase() ||
					t.trim().toLowerCase() === isInTargetRegion.province_name.toLowerCase() ||
					t.trim().toLowerCase() === isInTargetRegion.country_name.toLowerCase()
			);
		}
	} catch (error) {
		console.log(error);
	}
}
